import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { getUrl } from '@Builder/QuoteDetailPage/FilesTab/ConfigurationModal/logic'
import { THREADS_KEY } from '@Builder/QuoteDetailPage/FilesTab/ConfigurationModal/constants'

import Box from '~/core/Box'
import Link from '~/core/Link'
import Text from '~/core/Text'
import { BLACK_ALPHA_BOTTOM } from '~/apps/consumer/components/PartViewerModal/logic'
import { ThreadsConfiguredCardType } from '~/apps/consumer/components/PartViewerModal/types'
import styles from '~/apps/consumer/components/PartViewerModal/styles.css'

export default function ThreadsConfiguredCard(
    props: ThreadsConfiguredCardType,
) {
    const { holesCount, tapsCount, placement, setActivePage } = props

    const navigate = useNavigate()

    const { pathname } = useLocation()
    const { tabs } = useParams<{ tabs: string }>()

    const handleThreadsUrl = () => {
        if (pathname.indexOf('part') > -1) {
            const url = getUrl(pathname, tabs)

            navigate(`${url}/${THREADS_KEY}`)
        }
    }

    return (
        <Box
            borderBottom={BLACK_ALPHA_BOTTOM}
            padding="16px 0 16px"
            justifyContent="between"
        >
            {tapsCount && tapsCount > 0 ? (
                <>
                    <Box>
                        <Text className={styles.threadCount}>
                            {tapsCount}/{holesCount}
                        </Text>
                        <Text fontSize="14px" color="blackAlpha75">
                            threads configured
                        </Text>
                    </Box>
                    <Box>
                        <Link
                            target="_blank"
                            name="view threads"
                            placement={placement}
                            onClick={(evt: Event) => {
                                evt.preventDefault()
                                setActivePage(THREADS_KEY)
                                handleThreadsUrl()
                            }}
                        >
                            View threads
                        </Link>
                    </Box>
                </>
            ) : (
                <Text fontSize="14px" color="blackAlpha45">
                    {tapsCount}/{holesCount} threads configured
                </Text>
            )}
        </Box>
    )
}
